import {
  ICustomerRateCreate,
  ICustomerRateDetails,
  ICustomerRateListItem,
  ICustomerRateListSearch,
  IEditCustomerRatePayload,
} from "../../../types/master/customerRateInterface";
import { CustomerRateActionTypes, CustomerRateActions } from "../../actionTypes/master/customerRateActionTypes";

export const createCustomerRate = (payload: ICustomerRateCreate): CustomerRateActionTypes => ({
  type: CustomerRateActions.CREATE_CUSTOMER_RATE,
  payload,
});

export const getCustomerRateList = (payload: ICustomerRateListSearch): CustomerRateActionTypes => ({
  type: CustomerRateActions.GET_CUSTOMER_RATE_LIST,
  payload,
});

export const setCustomerRateList = (customerRateList: ICustomerRateListItem[]): CustomerRateActionTypes => ({
  type: CustomerRateActions.SET_CUSTOMER_RATE_LIST,
  payload: customerRateList,
});

export const setCustomerRateListPageCount = (payload: number): CustomerRateActionTypes => ({
  type: CustomerRateActions.SET_CUSTOMER_RATE_LIST_PAGE_COUNT,
  payload,
});

export const getCustomerRateDataById = (id: number | string): CustomerRateActionTypes => ({
  type: CustomerRateActions.GET_CUSTOMER_RATE_DATA_BY_ID,
  payload: id,
});

export const setCustomerRateDataById = (payload: ICustomerRateDetails): CustomerRateActionTypes => ({
  type: CustomerRateActions.SET_CUSTOMER_RATE_DATA_BY_ID,
  payload,
});

export const editCustomerRate = (payload: IEditCustomerRatePayload): CustomerRateActionTypes => ({
  type: CustomerRateActions.EDIT_CUSTOMER_RATE_DATA_BY_ID,
  payload,
});
